import React from 'react';
import { MessageDirection, TwilioMessage } from 'models/twilio';
import styled from 'styled-components';

import useTwilioMessage from 'components/twilio/hooks/useTwilioMessage';
import generateMessageId from 'components/twilio/utils/generateMessageId';

const MessageGroupContainer = styled.div<{ $isOutgoing: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: ${({ $isOutgoing }) => ($isOutgoing ? 'flex-end' : 'flex-start')};
`;

export interface MessageGroupProps {
  direction: MessageDirection;
  messages: TwilioMessage[];
}

const MessageGroup = ({ direction, messages }) => {
  const { getMessageComponent } = useTwilioMessage();
  return (
    <MessageGroupContainer className="twilio-message-group" $isOutgoing={direction === MessageDirection.OUTGOING}>
      {messages.map((message) => (
        <React.Fragment key={generateMessageId(message.index)}>
          {getMessageComponent(message, direction)}
        </React.Fragment>
      ))}
    </MessageGroupContainer>
  );
};

export default MessageGroup;
